<template>
    <div class="imagesContainer">
        <div class="bgTopo_container">
            <div v-for="img in imagens" :key="img.id">
                <img
                    :class="`fotoTopo opacity_${img.opacity}`"
                    :src="`${publicPath}static/images/${img.img}`"
                />
                <img
                    :class="`bgTopo opacity_${img.opacity}`"
                    :src="`${publicPath}static/images/${img.bg}`"
                />
            </div>
        </div>
        <div id="marqueWW" class="d-sm-none">
            <a href="whatsapp://send?phone=5585981495459&text="
                ><img :src="`${publicPath}static/images/whatsapp.png`"
            /></a>
        </div>
    </div>
</template>

<style scoped>
.imagesContainer {
    position: relative;
    height: 500px;
}
#marqueWW {
    position: absolute;
    width: 50px;
    height: 50px;
    z-index: 1000;
    bottom: -10px;
    left: 50%;
}
#marqueWW img {
    width: 210px;
}
.bgTopo_container {
    width: 100%;
    height: 500px;
    position: relative;
    background-color: #343a40;
    overflow: hidden;
}
.opacity_1 {
    opacity: 1;
}
.opacity_0 {
    opacity: 0;
}
.fotoTopo {
    z-index: 999;
    position: absolute;
    left: calc(50% - 360px);
    height: 500px;
    transition: 1s all;
}
.bgTopo {
    z-index: 998;
    width: 100%;
    height: 500px;
    position: absolute;
    left: 0px;
    transition: 1s all;
}
</style>

<script>
export default {
    name: 'FotosTopo',
    data() {
        return {
            imagens: [
                { img: 'img2.png', opacity: 1, bg: 'bg2.jpg' },
                { img: 'img1.png', opacity: 0, bg: 'bg1.jpg' },
            ],
            ativo: 0,
            proximo: 1,
            tempoFoto: 3,
            publicPath: process.env.BASE_URL,
        }
    },
    components: {},
    methods: {
        proximaFoto() {
            // muda opacidades
            this.imagens[this.ativo].opacity = 0
            this.imagens[this.proximo].opacity = 1

            this.ativo =
                this.ativo + 1 == this.imagens.length ? 0 : this.ativo + 1
            this.proximo =
                this.proximo + 1 == this.imagens.length ? 0 : this.proximo + 1
        },
    },
    mounted() {
        setInterval(() => {
            this.proximaFoto()
        }, this.tempoFoto * 1000)
    },
}
</script>
